import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-secondary-action-button',
  imports: [],
  templateUrl: './secondary-action-button.component.html',
  styleUrls: ['./secondary-action-button.component.scss']
})
export class SecondaryActionButtonComponent {
  @Output() clickEmitter = new EventEmitter();
  @Input() buttonText!: string;
  @Input() disabled = false;

  emitClick() {
    this.clickEmitter.emit();
  }
}
